export const Routes = {
  HOME: '/home',
  STUDIO: '/studio',
  PPT: '/ppt',
  AI_FLOW: '/ai_flow',
  NOT_FOUND: '/404',
} as const;
